export type ChartDrawingKind = "horizontal_line" | "horizontal_ray"
export type ChartDrawingSource = "user" | "ai_suggested" | "ai_chat"
export type ChartToolMode = "pan" | "horizontal_line" | "horizontal_ray"
export type AlertDirection = "above" | "below"
export type AlertConditionType = "level_cross" | "percent_from_prev_close"
export type AlertRepeatMode = "every_crossing" | "once"

export interface ChartAlertable {
  type: "Contract" | "Ticker"
  id: number
}

export interface ChartDrawing {
  id: number | string
  kind: ChartDrawingKind
  source: ChartDrawingSource
  price: number
  origin_time: string | null
  label: string | null
  color: string | null
  visible: boolean
  price_alert_id?: number | null
  ephemeral?: boolean
}

export interface PriceAlertRecord {
  id: number
  alertable_type: string
  alertable_id: number
  chart_drawing_id: number | null
  condition_type: AlertConditionType
  direction: AlertDirection
  threshold: number
  repeat_mode: AlertRepeatMode
  active: boolean
  expires_at: string | null
  description: string
  symbol?: string
  chart_path?: string | null
  last_triggered_at?: string | null
  events_count?: number
  /** A "once" alert that fired and turned itself off, as opposed to one the user paused. */
  disarmed_by_trigger?: boolean
}

export interface ChartOverlay {
  id: string
  kind: ChartDrawingKind
  source: ChartDrawingSource | "alert"
  price: number
  origin_time: string | null
  label: string | null
  color: string | null
  direction?: AlertDirection
  selected?: boolean
}

export const OVERLAY_COLORS: Record<string, string> = {
  user: "#22d3ee",
  ai_suggested: "#fbbf24",
  ai_chat: "#f59e0b",
  alert_above: "#2dd4bf",
  alert_below: "#fb7185",
}

export function drawingToOverlay(drawing: ChartDrawing, selected = false): ChartOverlay {
  return {
    id: String(drawing.id),
    kind: drawing.kind,
    source: drawing.source,
    price: drawing.price,
    origin_time: drawing.origin_time,
    label: drawing.label,
    color: drawing.color,
    selected,
  }
}

export function alertToOverlay(alert: PriceAlertRecord): ChartOverlay | null {
  if (alert.condition_type !== "level_cross" || !alert.active) return null
  return {
    id: `alert-${alert.id}`,
    kind: "horizontal_line",
    source: "alert",
    price: alert.threshold,
    origin_time: null,
    label: alert.description,
    color: alert.direction === "above" ? OVERLAY_COLORS.alert_above : OVERLAY_COLORS.alert_below,
    direction: alert.direction,
  }
}
